var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],class:{
    ltr_ecommerce: _vm.css_direction === 'ltr',
    rtl_ecommerce: _vm.css_direction === 'rtl',
    'ltr-on-rtl': !_vm.$store.getters.orientation && _vm.css_direction === 'rtl',
    rtl: _vm.$store.getters.orientation && _vm.css_direction === 'ltr',
  },attrs:{"id":"app"}},[(_vm.$store.getters.outlet || _vm.webviewGuard === true)?_c('div',{staticClass:"container_main data-container",style:({
      visibility:
        _vm.$store.getters.modal.search &&
        _vm.$store.getters.search &&
        _vm.$store.getters.search.query &&
        _vm.$store.getters.search.query.length > 0
          ? 'hidden'
          : 'visible',
    })},[(_vm.$store.getters.modal.block)?_c('block-popup'):_vm._e(),(_vm.$store.getters.outlet && !_vm.$store.getters.isBookingMode)?_c('TopBar'):_vm._e(),_c('transition',{attrs:{"name":'header-fade',"mode":"out-in"}},[(_vm.$route.name === 'home' && _vm.$store.getters.outlet)?_c('Header'):_vm._e()],1),_c('keep-alive',[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c('router-view')],1)],1)],1):_vm._e(),(
      (_vm.$route.name === 'home' || _vm.$route.name === 'catalog') &&
      _vm.$store.getters.outlet &&
      !_vm.$store.getters.overlay
    )?_c('Footer'):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.outlet),expression:"$store.getters.outlet"}],staticClass:"container_main modal-container",style:({ minHeight: '0' })},[_c('CallWaiterModal'),_c('SearchModal'),_c('SystemPopup'),(
        _vm.$store.getters.outletSettings &&
        _vm.$store.getters.outletSettings.delivery_type !== 4
      )?_c('Product'):_vm._e(),(
        _vm.$store.getters.outletSettings &&
        _vm.$store.getters.outletSettings.delivery_type === 4
      )?_c('Resource'):_vm._e(),(
        _vm.$store.getters.outletSettings &&
        _vm.$store.getters.outletSettings.delivery_type === 4
      )?_c('DateFilter'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }